angular.module("LeasePilot").directive("leaseVar", [
  "$filter",
  "$rootScope",
  "$sanitize",
  "$timeout",
  "LeaseVarService",
  "LabelsService",
  function(
    $filter,
    $rootScope,
    $sanitize,
    $timeout,
    LeaseVarService,
    LabelsService
  ) {
    const leaseVarLink = function(scope, element, attrs) {
      const appScope = $rootScope.findAppScope();

      if (!window.isLeaseIfDeprecated) {
        element.on("click", function(e) {
          return LeaseVarService.leaseVarClick(e, scope, element, attrs);
        });
      } else {
        if (
          attrs.name &&
          LeaseVarService.isChangeStructure(
            $rootScope.leaseVarStructureChangeMap,
            attrs.name
          )
        ) {
          element[0].setAttribute("non-click", true);
        } else {
          element.on("click", function(e) {
            return LeaseVarService.leaseVarClick(e, scope, element, attrs);
          });
        }
      }

      scope.$watch("[name, calc, isChanging]", function(newval) {
        if (attrs.name === "building.name") {
          if (appScope.building?.displayName) {
            newval[0] = appScope.building.displayName;
          }
        }

        if (appScope.features?.supportSmartQuotes) {
          if (newval[0] && typeof newval[0] === "string") {
            // Replace straight quotes with curly quotes and straight apostrophe with curly apostrophe
            const text = newval[0];
            let modifiedText = text;

            // First, normalize all quotes to straight quotes to ensure consistent processing
            modifiedText = modifiedText
              .replace(/[\u201C\u201D]/g, '"') // Replace curly double quotes
              .replace(/[\u2018\u2019]/g, "'"); // Replace curly single quotes

            // Replace double quotes
            let openQuote = true;
            modifiedText = modifiedText.replace(/"/g, () => {
              openQuote = !openQuote;
              return !openQuote ? "\u201C" : "\u201D";
            });

            // Replace single quotes/apostrophes
            modifiedText = modifiedText.replace(/'/g, (match, offset) => {
              // If it's at the start of the text or after a space, it's an opening quote
              if (offset === 0 || modifiedText[offset - 1] === " ") {
                return "\u2018";
              }
              return "\u2019";
            });

            if (modifiedText !== text) {
              newval[0] = modifiedText;
              scope.name = modifiedText;
            }
          }
        }

        return LeaseVarService.leaseVarChangeWatch(
          newval,
          scope,
          element,
          attrs
        );
      });

      $timeout(function() {
        LeaseVarService.setTitle(scope, element, LabelsService);
      });
    };

    return {
      restrict: "E",
      scope: {
        inputLs: "@",
        ll: "=",
        ev: "@",
        name: "=",
        varName: "@name",
        calc: "=",
        f1: "@",
        f1Options: "@",
        f2: "@",
        f2Options: "@",
        f3: "@",
        f3Options: "@",
        isChanging: "="
      },
      link: leaseVarLink
    };
  }
]);
